<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>签约客户</h2>
        <p>
          查看已签约客户、签约项目、金额、订单状态和回款状态，并预留跳转订单、文书、合同、付款记录入口。
        </p>
      </div>
      <div class="crm-actions">
        <el-button icon="el-icon-link" @click="notifyPending('对接订单管理')"
          >对接订单管理（待开发）</el-button
        >
      </div>
    </div>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>签约客户列表</span>
        <el-tag size="mini" type="success"
          >{{ signedCustomers.length }} 条</el-tag
        >
      </div>
      <el-table :data="signedCustomers" stripe border>
        <el-table-column
          prop="name"
          label="客户姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column label="手机号" min-width="160">
          <template slot-scope="scope">
            <crm-phone-field :phone="scope.row.phone" status="pending" />
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="signedProject"
          label="签约项目"
          min-width="160"
        ></el-table-column>
        <el-table-column prop="signedAmount" label="签约金额" width="120">
          <template slot-scope="scope"
            >¥{{
              Number(scope.row.signedAmount || 0).toLocaleString()
            }}</template
          >
        </el-table-column>
        <el-table-column
          prop="signedAt"
          label="签约时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="ownerName"
          label="归属员工"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="orderStatus"
          label="订单状态"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="paymentStatus"
          label="回款状态"
          min-width="120"
        ></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="notifyPending(`查看 ${scope.row.name} 合同`)"
              >查看合同</el-button
            >
            <el-button
              type="text"
              @click="notifyPending(`查看 ${scope.row.name} 付款记录`)"
              >付款记录</el-button
            >
            <el-button
              type="text"
              @click="notifyPending(`跳转订单：${scope.row.name}`)"
              >订单管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { loadCrmState } from "./mock";
import CrmPhoneField from "./PhoneField.vue";

export default {
  name: "CrmSignedCustomers",
  components: { CrmPhoneField },
  data() {
    return {
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
    };
  },
  computed: {
    signedCustomers() {
      return (this.state.customers || []).filter(
        (item) => item.mainStatus === "已签约"
      );
    },
  },
  methods: {
    notifyPending(label) {
      this.$message.warning(`${label}为预留入口，二阶段接真实业务跳转。`);
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
